export default {
  features: {
    problemCaseUpdateStatus: {
      placeholder: 'Выберите статус',
      processing: 'В процессе',
      completed: 'Выполнено',
    },
  },
};
